import { MicroHeaderXS } from "features/shared/styles/typography/MicroHeaderXS.styled";
import styled from "styled-components";

import { SmallPrint } from "../../../../../../shared/styles/typography/SmallPrint.styled";

const PreviewField = styled.div`
  position: absolute;
  max-width: 110px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${SmallPrint} {
    color: ${({ theme }) => theme.colors.base5};
    margin-bottom: ${({ theme }) => theme.passportPreviewValueMargin};
  }

  ${MicroHeaderXS} {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default PreviewField;
